<template>
  <div class="main">
    <c-panel>
      <itens></itens>
    </c-panel>
  </div>
</template>

<script>
import itens from "./itens"

export default {
  components: { itens }
}
</script>

